import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PictureComponent } from '../../../../../../shared/components/picture/picture.component';
import { LazyImageDirective } from '../../../../../../directive/lazyImage.directive';
import { NgIf, NgClass } from '@angular/common';
import { AppearDirective } from '../../../../../../directive/appear.directive';

@Component({
    selector: 'app-step-two',
    templateUrl: './step2.component.html',
    styleUrls: ['./step2.component.scss'],
    standalone: true,
    imports: [AppearDirective, NgIf, LazyImageDirective, NgClass, PictureComponent, TranslateModule]
})
export class Step2Component implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(window.innerWidth <= 900 ) {
      if(!this.mobileMode) {
        this.mobileMode = !this.mobileMode;
      }
    } else {
      if(this.mobileMode) {
        this.mobileMode = !this.mobileMode;
      }
    }
  }

  mobileMode: Boolean
  animate = false;

  ngOnInit() {
    window.innerWidth <= 900 ? this.mobileMode = true : this.mobileMode = false;
  }

  onAppear() {
    this.animate = true;
  }

}
